// Pinned Linux images and runtimes: the single source of truth for the server's image cache
// (src/server/lib/linux-images.js) and the /linux page. Plain data, safe to import anywhere.

// v86 images the server fetches once, verifies and serves same-origin with Range (the browser
// can't fetch them: Alpine's CDN sends no CORS headers). Verified 2026-09-19/23: booted to a
// root login in v86 0.5.461 with 256 MiB (size + sha256 from Alpine's latest-releases.yaml).
export const LINUX_IMAGES = [
	{
		id: "alpine-virt-3.24.2-x86",
		name: "Alpine Linux 3.24.2",
		kind: "iso",
		url: "https://dl-cdn.alpinelinux.org/alpine/v3.24/releases/x86/alpine-virt-3.24.2-x86.iso",
		size: 51380224,
		sha256: "62e752e0f674b1537a7fc38d9c3e6eab9644ae93e8610efb64756a00e7592a10",
		memory: 256,
		licence: "Alpine Linux is free to redistribute; its packages carry their own open-source licences.",
	},
];
// CheerpX disks Re:Vault builds and serves itself (tools/debian-desktop). They have no upstream `url`:
// they exist on a server only after `node tools/linux-image-install.mjs <file>` verified and placed
// them, and they are streamed to CheerpX's HttpBytesDevice with Range from <linux prefix>i/<key>.
// Machines refer to them as "rv:<id>", resolved to the current origin at start time.
// Filled in by tools/debian-desktop/build.sh output (size + sha256 of the built ext2 image).
export const CHEERPX_IMAGES = [
	{
		id: "debian-desktop-12",
		name: "Debian 12 desktop",
		kind: "ext2",
		size: 1468006400,
		sha256: "fe9ceee60960d9f0b7e4bdeefbc94cf18d79ad2cec35f73094a83b1aaa6e4fa2",
		licence: "Debian is free software; each package carries its own licence (see /usr/share/doc in the machine).",
	},
];
export const cheerpxImage = (id) => CHEERPX_IMAGES.find((i) => i.id === id) || null;

// Opaque URL key: the first 16 hex chars of the sha256 (content-addressed, so cacheable forever).
export const imageKey = (img) => img.sha256.slice(0, 16);
export const catalogImage = (id) => LINUX_IMAGES.find((i) => i.id === id) || null;

// CheerpX (Leaning Technologies). The Community License requires loading the runtime from
// their CDN - never self-host or bundle it. 1.3.9 is pinned (newer builds returned 204 on
// 2026-09-18); every published build is immutable, so bump deliberately and re-test.
export const CHEERPX_RUNTIME_URL = "https://cxrtnc.leaningtech.com/1.3.9/cx.esm.js";
export const CHEERPX_RUNTIME_HOST = "cxrtnc.leaningtech.com";
// Leaning's public WebVM disks, streamed over WebSocket (CloudDevice). Never mirrored.
export const CHEERPX_DEBIAN_IMAGE = "wss://disks.webvm.io/debian_buster_large_permis_fixed_01-06-2026.ext2";
export const CHEERPX_DESKTOP_IMAGE = "wss://disks.webvm.io/alpine_20251007.ext2";
